module.exports = __webpack_public_path__ + "img/d_azufre_h.b824e0ff.png";